import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeliverynoteModel } from './deliverynote.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { InvoiceLineModel } from './invoiceline.model';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { DeliveryNoteService } from './deliverynote.service';
import { UserContactService } from '../../user/usercontact/usercontact.service';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ActivityService } from "../../user/activity/activity.service";
import { CoreComponent } from '../../../core/header/core.component';
import { UserCompanyModel } from '../../user/usercompany/usercompany.model';
import { AccountingModel } from '../../user/accountingModel/accountingModel.model';
import { AccountingModelService } from '../../user/accountingModel/accountingModel.service';
import { ConceptService } from '../../concept/concept/concept.service';
import { ConceptModel } from '../../concept/concept/concept.model';
import { ActualSelected, Utils } from '../../../shared/utils';

@Component({
    selector: 'convfact-deliverynote',
    templateUrl: './deliverynote.component.html',
    styleUrls: ['./deliverynote.component.css'],
    standalone: false
})

export class DeliveryNoteComponent implements OnInit {
  deliverynote = new DeliverynoteModel;
  contacts: ContactModel[] = [];
  concepts: ConceptModel[] = [];
  accountsAndTaxes = new AccountsAndTaxesModel;
  bankAccounts: BankAccountModel[] = [];
  userCompany: UserCompanyModel;
  accountings: AccountingModel[] = [];

  errors = {};
  ready: boolean = false;
  spinner: boolean = false;
  isProjectEnable: boolean = false;

  submit(): void { }

  constructor(
    private deliverynoteService: DeliveryNoteService,
    private contactService: ContactService,
    private conceptService: ConceptService,
    private userContactService: UserContactService,
    private userCompanyService: UserCompanyService,
    private bankAccountService: BankAccountService,
    private activityService: ActivityService,
    private route: ActivatedRoute,
    private router: Router,
    private accountingModelService: AccountingModelService,
    public snackBar: MatSnackBar,
    private core: CoreComponent,
  ) { }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public saveData(deliverynote: DeliverynoteModel): void {
    deliverynote.activityUid = this.core.activitySelected;
    deliverynote.fiscalYear = this.core.yearSelected;
    this.ready = false;
    if (deliverynote.uid == null) {
      this.deliverynoteService.addData(deliverynote)
        .then(deliverynote => {
          this.deliverynote = deliverynote;
          this.spinner = false;
          this.deliverynoteService.saveRequestUpdateValue(false);
          this.returnToIndex();
        })
        .catch(errors => {
          this.ready = true;
          this.deliverynoteService.saveRequestUpdateValue(false);
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
          }
        });
    }
    else {
      this.deliverynoteService.editData(deliverynote.uid, deliverynote)
        .then(deliverynote => {
          this.deliverynote = deliverynote;
          this.ready = true;
          this.deliverynoteService.saveRequestUpdateValue(false);
          this.returnToIndex();
        })
        .catch(errors => {
          this.ready = true;
          this.deliverynoteService.saveRequestUpdateValue(false);
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
          }
        })
    }
  }

  ngOnInit() {
    this.deliverynote.invoiceLines = new Array<InvoiceLineModel>();
    this.deliverynote.invoiceLines.push(new InvoiceLineModel());
    this.deliverynote.conditions = false;

    this.bankAccountService.getList().then(bankAccounts => this.bankAccounts = bankAccounts.list);

    this.deliverynoteService.accountsAndTaxesData().then(accountsAndTaxes => this.accountsAndTaxes = accountsAndTaxes);

    // this.accountingModelService.getList().then(data => this.accountings = data);

    this.contactService.getListClients().then(contacts => this.contacts = contacts);

    this.conceptService.getList().then(concepts => this.concepts = concepts);

    this.route.params.subscribe(params => {
      this.deliverynote.preInvoiceNumber = "";
      const uid = params['uid'];
      if (uid != null) {
        this.deliverynoteService.loadData(uid).then(deliverynote => {
          this.deliverynote = deliverynote;
          this.ready = true;
        })
      } else {
        this.deliverynote.invoiceRelease = new Date();
        this.deliverynote.invoiceExpiration = new Date();

        this.deliverynote.invoiceLines = new Array<InvoiceLineModel>();

        this.userCompanyService.loadData().then(userCompany => {
          this.userCompany = userCompany;
          this.deliverynote.issuerName = userCompany.companyName;
          this.deliverynote.issuerVatNumber = userCompany.vatNumber;
          this.deliverynote.preInvoiceNumber = userCompany.lastDeliverynote;
        })

        this.activityService.loadData(this.core.activitySelected).then(response => {
          this.deliverynote.preInvoiceNumber = response.deliveryNoteNumber;
          this.spinner = false;
          this.ready = true;
        });
         this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
               this.isProjectEnable = activity.isProject;
             });
      }

      this.userContactService.loadData().then(userContact => {

        if (Utils.IsNullOrEmpty(this.deliverynote.issuerAddress)) {
          this.deliverynote.issuerAddress = userContact.address;
        }

        if (Utils.IsNullOrEmpty(this.deliverynote.issuerPostalCode)) {
          this.deliverynote.issuerPostalCode = userContact.postalCode;
        }

        if (Utils.IsNullOrEmpty(this.deliverynote.issuerLocation)) {
          this.deliverynote.issuerLocation = userContact.location;
        }

        if (Utils.IsNullOrEmpty(this.deliverynote.issuerCountry)) {
          this.deliverynote.issuerCountry = userContact.country;
        }

        if (Utils.IsNullOrEmpty(this.deliverynote.issuerState)) {
          this.deliverynote.issuerState = userContact.state;
        }

      });


    });

  }

  returnToIndex(): void {
    this.router.navigate(['invoice/deliverynote']);
  }
}
